import React from 'react';
import PreviewPopoverLink from '../PreviewPopover/PreviewPopoverLink';
import ReservationSegmentCheckInCustomersSelect from '../ReservationSegmentCheckIn/ReservationSegmentCheckInCustomersSelect';
import ModalButtons from '../ModalButtons/ModalButtons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default class ReservationSegmentBuilderEditGuestDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      customers: this.props.reservation_segment.customers,
      loading: false,
    }
    this.onChangeCustomers = this.onChangeCustomers.bind(this)
  }

  render() {
    var self = this;

    var buttons = this.setButtons()

    return(
      <div className="ReservationSegmentBuilderEditGuestDetails">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title pull-left">{I18n.t('guest_details')}</h3>
            <div className="clearfix"></div>
          </div>
          <div className="panel-body container">
            <div className="row">
              <div className="col-md-6 form-group">
                <label>{I18n.t('checked_in_by')} <span className="ss-help help" title={I18n.t('checked_in_by_helper_text')}></span></label>
                {
                this.props.reservation_segment.incidental_deposit_card_customer
                ?
                  <div><PreviewPopoverLink model_type="customer" model_id={this.props.reservation_segment.incidental_deposit_card_customer.id} text={this.props.reservation_segment.incidental_deposit_card_customer.full_name} /></div>
                :
                  null
                }
              </div>
              <div className="col-md-6 form-group">
                <label>{I18n.t('booked_by')}</label>
                <div><PreviewPopoverLink model_type='customer' model_id={this.props.reservation_segment.reservation_customer.id} text={this.props.reservation_segment.reservation_customer.full_name}/></div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 form-group">
                <label>{I18n.t('customers_staying_in_room')}</label>
                <ReservationSegmentCheckInCustomersSelect  customers={self.state.customers} onChange={self.onChangeCustomers} />
                <div className="pull-right" style={{marginTop: 7, marginRight: -7}}>
                  <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="btn btn-link btn-xs modal-iframe">{I18n.t('new_customer')}</a>
                </div>
              </div>
              {/* <div className="col-md-6 form-group">
                <label>{I18n.t('booking_phone_number')}</label>
                <div>
                  {this.props.reservation.booking_phone_number}
                </div>
              </div> */}
            </div>
          </div>

        </div>
      <ModalButtons loading={this.state.loading} buttons={buttons} />
      <LoadingSpinner show={this.state.loading} />

      </div>
    );
  };

  setButtons() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function(e) {
          self.save()
          return false;
        }
      }
    ];
    return buttons
  };

  onChangeCustomers(customers) {
    let guests = Object.assign({}, this.state.customers)
    guests = customers

    this.setState({
      customers: guests,
    });
  };

  save() {
    var self = this;
    this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: `/admin/reservation_segments/${self.props.reservation_segment.id}/guests`,
      data: {
        reservation_segment: {
          id: self.props.reservation_segment.id,
          customer_ids: self.state.customers.map((customer) => {return customer.id}),
        },
      }
    }).done(function(data) {
      if (data.errors && data.errors.length) {
        this.setState({errors: data.errors, loading: false});
      } else {
        if(parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("updated_successfully"));
        }
        if(parent && parent.hide_modal) {
          parent.hide_modal();
        }
      };
    });

  };

};
